import { render } from "./CartMenuIcon.vue?vue&type=template&id=3930177a"
import script from "./CartMenuIcon.vue?vue&type=script&lang=js"
export * from "./CartMenuIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app/components/CartMenuIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3930177a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3930177a', __exports__)) {
    api.reload('3930177a', __exports__)
  }
  
  module.hot.accept("./CartMenuIcon.vue?vue&type=template&id=3930177a", () => {
    api.rerender('3930177a', render)
  })

}


export default __exports__